<template>
  <base-modal :formTitle="formTitle">
    <template v-slot:body>
      <v-row>
        <v-col cols="12" sm="12" md="4">
          <v-text-field
            v-model="modalidade.descricao"
            :rules="[
              () => !!modalidade.descricao || 'Esse campo é obrigatório!',
            ]"
            ref="descricao"
            label="Descrição"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-text-field
            v-model="modalidade.pbt"
            :rules="[() => !!modalidade.pbt || 'Esse campo é obrigatório!']"
            ref="pbt"
            label="PBT"
            v-mask="['##.###']"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-text-field
            v-model="modalidade.eixo"
            :rules="[() => !!modalidade.eixo || 'Esse campo é obrigatório!']"
            ref="eixo"
            label="Eixo"
            v-mask="['#']"
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:buttons>
      <buttons-cadastro @close="close" @save="save" />
    </template>
  </base-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BaseModal from '@/components/BaseModal/BaseModal.vue'
import ButtonsCadastro from '@/components/ButtonsCadastro/ButtonsCadastro.vue'

export default {
  components: { BaseModal, ButtonsCadastro },
  name: 'CadastroModalidade',
  props: {
    modalidade: Object,
    formTitle: String,
    modalidadeIndex: Number,
  },

  data() {
    return {
      formError: false,
      defaultItem: {
        descricao: '',
        pbt: '',
        eixo: '',
      },
    }
  },

  computed: {
    ...mapState('auth', ['empresaAtual']),
    form() {
      return {
        descricao: this.modalidade.descricao,
        pbt: this.modalidade.pbt,
        eixo: this.modalidade.eixo,
      }
    },
  },

  methods: {
    ...mapActions('patio', [
      'getModalidades',
      'addModalidade',
      'editModalidade',
      'deleteModalidade',
    ]),

    resetarFormulario() {
      this.formError = false

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].reset()
      })
    },

    close() {
      this.formError = false
      setTimeout(() => {
        Object.assign(this.modalidade, this.defaultItem)
        this.resetarFormulario()
      }, 300)

      this.$emit('close')
    },

    verificaFormulario() {
      this.formError = false

      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) this.formError = true

        this.$refs[f].validate(!this.form[f])
      })
    },

    save() {
      this.verificaFormulario()
      if (this.formError) return

      if (this.modalidade.pbt.search(/[.]/g) > -1) {
        this.modalidade.pbt = this.modalidade.pbt.replace('.', '')
      }
      if (this.modalidadeIndex > -1) {
        this.editModalidade(this.modalidade)
      } else {
        this.modalidade.proprietario = this.empresaAtual.public_id
        this.addModalidade(this.modalidade)
      }

      this.close()
    },
  },
}
</script>
<style>
</style>